import {createFileRoute} from '@tanstack/react-router'
import {WalletDeposit} from "@/components/wallet/WalletDeposit/WalletDeposit.tsx"

export const Route = createFileRoute('/_mainLayout/wallet/wait/deposit/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <WalletDeposit/>
}
